import { useEffect, useState } from 'react'

export const useVippsCheckout = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    // Check if scripts are already loaded
    if (typeof window !== 'undefined' && window.VippsCheckoutDirect) {
      setIsLoaded(true)
      return
    }

    // Load scripts dynamically
    const loadVippsScripts = async () => {
      setIsLoading(true)
      setError(null)

      try {
        // Load the main SDK
        await new Promise((resolve, reject) => {
          const script1 = document.createElement('script')
          script1.src = 'https://checkout.vipps.no/vippsCheckoutSDK.js'
          script1.async = true
          script1.onload = resolve
          script1.onerror = () => reject(new Error('Failed to load Vipps Checkout SDK'))
          document.head.appendChild(script1)
        })

        // Load the checkout button script
        await new Promise((resolve, reject) => {
          const script2 = document.createElement('script')
          script2.src = 'https://checkout.vipps.no/checkout-button/v1/vipps-checkout-button.js'
          script2.async = true
          script2.onload = resolve
          script2.onerror = () => reject(new Error('Failed to load Vipps Checkout Button script'))
          document.head.appendChild(script2)
        })

        setIsLoaded(true)
      } catch (error) {
        console.error('Failed to load Vipps scripts:', error)
        setError(error instanceof Error ? error.message : 'Failed to load Vipps scripts')
      } finally {
        setIsLoading(false)
      }
    }

    loadVippsScripts()
  }, [])

  return { isLoaded, isLoading, error }
}
